import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const appBaseUrl = document.getElementsByTagName('base')[0].href;
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App baseUrl={appBaseUrl}/>
  </BrowserRouter>,
  rootElement);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js